import React from 'react';
import styles from './Banner.module.css';

const InfoIcon = (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
         strokeLinecap="round" aria-hidden="true" {...props}>
        <circle cx="12" cy="12" r="9"/>
        <path d="M12 11v5M12 8h.01"/>
    </svg>
);

/**
 * An inline page-level notice. `tone`: 'warning' (paid-disabled) | 'info'
 * (free trial, not-org-owner). Never used for destructive confirmation -
 * that's ConfirmDialog.
 */
const Banner = ({tone = 'info', children}) => (
    <div role="status" className={`${styles.banner} ${styles[tone]}`}>
        <InfoIcon className={styles.icon}/>
        <span>{children}</span>
    </div>
);

export default Banner;
